import Vue from 'vue';
import store from '~/base_store';

function toUpper(_, c) {
    return c ? c.toUpperCase() : '';
}

function classify(str) {
    const classifyRE = /(?:^|[-_/])(\w)/g;
    return str && str.replace(classifyRE, toUpper);
}

export function initializeComponents(selector, implementation, options) {
    const $els = $(selector);
    let ref;
    const componentOptions = options && options.componentOptions
        ? options.componentOptions
        : {};

    window.gl = window.gl || {};

    if ($els.length === 0) {
        return;
    }

    if ($els.length === 1) {
        ref = options && options.hasOwnProperty('ref')
            ? options.ref
            : classify(implementation.name);
    }

    if (ref && gl[ref]) {
        gl[ref].$destroy(true);
    }

    const component = Vue.extend(implementation);

    $els.each((index, el) => {
        const instance = new component({
            el,
            propsData: $(el).data(),
            store,
            ...componentOptions
        });

        if (options && options.hasOwnProperty('onInit') && typeof options.onInit === 'function') {
            options.onInit(instance, $(el).data());
        }

        if (ref) {
            gl[ref] = instance;
        }
    });
}
